import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  ConfirmationAlertCallbackInput,
  ConfirmationAlertDialog,
  ConfirmationAlertUniqueProps,
} from '../confirmation-alert-dialog';

// Create the hooks inside a function to avoid initialization issues
const createHooks = () => {
  const { useDialogForContext, useDialog: useConfirmationAlertDialog } =
    getDialogHooks<
      ConfirmationAlertUniqueProps,
      ConfirmationAlertCallbackInput
    >(ConfirmationAlertDialog);
  return { useDialogForContext, useConfirmationAlertDialog };
};

// Defer hook creation until first use to avoid circular dependency issues
let hooksCache: ReturnType<typeof createHooks> | null = null;

const getHooks = () => {
  if (!hooksCache) {
    hooksCache = createHooks();
  }
  return hooksCache;
};

export const useConfirmationAlertDialogForContext = () =>
  getHooks().useDialogForContext();
export default () => getHooks().useConfirmationAlertDialog();
